import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import AiAdminLogin from "./login";
import AiAdminDashboard from "./dashboard";
import AiAdminKnowledge from "./knowledge";
import AiAdminConfigs from "./configs";
import AiAdminShopUsage from "./shop-usage";
import AiAdminConversations from "./conversations";
import AiAdminAuditLogs from "./audit-logs";

const AiAdminApp = () => {
  return (
    <Switch>
      <Route path="/login" component={AiAdminLogin} />
      <Route path="/dashboard" component={AiAdminDashboard} />
      <Route path="/knowledge" component={AiAdminKnowledge} />
      <Route path="/configs" component={AiAdminConfigs} />
      <Route path="/shop-usage" component={AiAdminShopUsage} />
      <Route path="/conversations" component={AiAdminConversations} />
      <Route path="/audit-logs" component={AiAdminAuditLogs} />
      <Redirect to="/dashboard" />
    </Switch>
  );
};

export default AiAdminApp;
